import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "../../../images/logo.png";
import logo2 from "../../../images/logo2.png";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/AboutUs", label: "About" },
    { to: "/Services", label: "Services" },
    { to: "/Leadership", label: "Leadership" },
    { to: "/Activity", label: "Activities" },
    { to: "/Gallery", label: "Gallery" },
    { to: "/Contact", label: "Contact" },
  ];

  return (
    <>
      {/* TOP BAR */}
      <div className="topbar">
        <div className="container">
          <div className="topbar-inner">
            <div className="topbar-contact">
              <span className="topbar-item">
                <ion-icon name="call-outline"></ion-icon>
                <a href="tel:+256777114327">+256 777 114 327</a>
              </span>
              <span className="topbar-item">
                <ion-icon name="mail-outline"></ion-icon>
                <a href="mailto:info@yitalife.com">info@yitalife.com</a>
              </span>
              <span className="topbar-item">
                <ion-icon name="location-outline"></ion-icon>
                Makerere Kavule, Phlona Medical Chambers
              </span>
            </div>
            <Link to="/Appointment">
              <button className="topbar-book">BOOK APPOINTMENT</button>
            </Link>
          </div>
        </div>
      </div>

      {/* MAIN NAV */}
      <nav className={`navbar-main${scrolled ? " scrolled" : ""}`}>
        <div className="container">
          <div className="navbar-inner">
            {/* Logo */}
            <Link to="/" className="navbar-logo" aria-label="Yitalife - Home">
              <img className="logo-img" alt="Yitalife logo - Yita Medical Services" src={logo} />
              <img className="logo-text-img" alt="Yitalife" src={logo2} />
            </Link>

            {/* Desktop Nav Links */}
            <ul className={`nav-links${menuOpen ? " open" : ""}`}>
              {navLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className={location.pathname === to ? "active" : ""}
                    onClick={() => setMenuOpen(false)}
                  >
                    {label}
                  </Link>
                </li>
              ))}
              <li>
                <div className="nav-social">
                  <a
                    href="https://x.com/yitalife"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Twitter"
                  >
                    <ion-icon name="logo-twitter"></ion-icon>
                  </a>
                  <a
                    href="https://www.facebook.com/yitalife.yms?mibextid=LQQJ4d"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                    <ion-icon name="logo-facebook"></ion-icon>
                  </a>
                  <a
                    href="mailto:info@yitalife.com"
                    aria-label="Email"
                  >
                    <ion-icon name="mail-outline"></ion-icon>
                  </a>
                </div>
              </li>
            </ul>

            {/* Hamburger */}
            <button
              className={`hamburger${menuOpen ? " open" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>
        </div>
      </nav>

      {/* SLOGAN BAR */}
      <div className="slogan-bar">
        "A Doctor in the Comfort of Your Home"
      </div>

      {/* DONATE BUTTON */}
      <div className="donate-fixed">
        <a href="#donate-modal">
          <button className="donate-fixed-btn">DONATE</button>
        </a>
      </div>

      {/* DONATE MODAL */}
      <div id="donate-modal" className="modal-window">
        <div className="modal-inner">
          <a href="#" title="Close" className="modal-close">✕ Close</a>
          <h5>Support Our Mission - Donate</h5>

          <ul className="donate-list">
            <li>
              <img
                src="http://flashugnews.com/wp-content/uploads/2022/07/Airtel-Money-Rates-in-Uganda-2022.jpeg"
                alt="Airtel Money"
              />
              <label>
                0705920614
                <p>Mirembe Joel</p>
              </label>
            </li>
            <li>
              <img
                src="https://www.african-markets.com/images/markets/jse/MTN-logo.jpg"
                alt="MTN MoMo"
              />
              <label>
                MOMOPA: 485644
                <p>Yita Life Medical Services</p>
              </label>
            </li>
          </ul>

          <hr style={{ margin: "16px 0", borderColor: "var(--mid-gray)" }} />

          <div className="donate-bank">
            <img
              src="http://freedomcity.co.ug/wp-content/uploads/2016/08/centenary-bank.png"
              alt="Centenary Bank"
            />
            <label>
              CENTENARY BANK
              <p>Account: 3201730226</p>
            </label>
          </div>
        </div>
      </div>


    </>
  );
}
